export type WelcomeTextsProps = {
  titleSrc: string;
  titleClassName: string;
  descriptionSrc: string;
  descriptionClassName: string;
};

/** Welcome title/header + description image pair. */
export function WelcomeTexts({
  titleSrc,
  titleClassName,
  descriptionSrc,
  descriptionClassName,
}: WelcomeTextsProps) {
  return (
    <>
      <img
        className={titleClassName}
        src={titleSrc}
        alt=""
        draggable={false}
        aria-hidden
      />
      <img
        className={descriptionClassName}
        src={descriptionSrc}
        alt=""
        draggable={false}
        aria-hidden
      />
    </>
  );
}
